// O tradutor do navegador não derruba mais a tela (12/10/2026).
//
// Medido: com o Google Tradutor do Chrome ligado, o /welcome-hp francês caiu em "Un problème est
// survenu" na troca do e-mail para o código (a conta foi criada, o código chegou, e não havia campo
// para digitá-lo). O tradutor troca cada nó de texto por <font><font>…</font></font>; quando o React
// vai tirar ou inserir junto do nó original, que já não está na tela, o DOM lança NotFoundError e a
// árvore inteira cai no ErrorBoundary. Vale para os dois mercados: quem traduz o americano cai igual.
//
// Parte da saída vem do próprio React (facebook/react#11538): se o nó já não é filho de quem o React
// pensa, ignorar a remoção. No insertBefore o original de lá devolve o nó SEM inserir; aqui ele vai
// para o fim do pai, de propósito, senão o campo do código nunca entraria na tela. Sem tradutor a
// referência é sempre filha e nada muda. Com tradutor, o texto pode ficar desatualizado ou fora de
// ordem até a próxima troca de tela; a tela não morre.
// Prova: scratchpad/fr/tradutor-simulado.md (vermelho sem este arquivo, verde com).
export function protegerContraTradutor(): void {
  if (typeof Node !== 'function' || !Node.prototype) return;
  const removeChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T, ...resto: unknown[]): T {
    if (child && child.parentNode !== this) return child;
    return (removeChild as (...a: unknown[]) => T).apply(this, [child, ...resto]);
  };
  const insertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(this: Node, ...args: unknown[]): T {
    const referencia = args[1] as Node | null | undefined;
    if (referencia && referencia.parentNode !== this) return insertBefore.call(this, args[0] as T, null) as T;
    return (insertBefore as (...a: unknown[]) => T).apply(this, args);
  };
}

protegerContraTradutor();
